<template>
  <v-app>
    <Snackbar />
    <RouterView />
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar';

export default {
  name: 'App',

  components: {
    Snackbar
  },

  data: () => ({}),
  mounted() {}
};
</script>
